import { Icon, palette } from '@centivo/react-components'
import styled from 'styled-components'

const PreferredBadgeContainer = styled.div`
  position: absolute;
  right: 5rem;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
`

const PreferredBadgeIconContainer = styled.span`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  width: 2.5rem;
  height: 2.5rem;
  background-color: ${palette.brand.orange};
  border-radius: 0 0 0.25rem 0.25rem;

  svg {
    flex-shrink: 0;
  }
`

const PreferredBadgeText = styled.p`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${palette.brand.darkGreen};
`

export const PreferredBadge = () => {
  return (
    <PreferredBadgeContainer>
      <PreferredBadgeIconContainer>
        <Icon icon="star" color={palette.neutral.white} size="1.5rem" />
      </PreferredBadgeIconContainer>
      <PreferredBadgeText>PREFERRED</PreferredBadgeText>
    </PreferredBadgeContainer>
  )
}
